import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ArrowNarrowLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4.83333 13.3333L1.5 9.99996M1.5 9.99996L4.83333 6.66663M1.5 9.99996H13.5C15.7091 9.99996 17.5 11.7908 17.5 14V15.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowNarrowLeftIcon;